import Box from '@mui/material/Box';
import { useAuth } from 'src/contexts/AuthContext';
import { Link } from '../Link';
import { ShareLikedCount } from '../ShareLikedCount';

export function UserLikedCount() {
  const { user, userData } = useAuth();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        mr: 2,
      }}
    >
      {!!userData && (
        <Link
          href={`/profile/${user?.uid}/liked-items`}
          sx={{ textDecoration: 'none' }}
        >
          <ShareLikedCount
            guardTitle="Track favourites?"
            likesOriginal={userData.likedPaths?.length || 0}
          />
        </Link>
      )}
    </Box>
  );
}
